/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable react/prop-types */
var React = require("react");
var classnames = require("classnames");
var Input_1 = require("./Input");
var InputPassword = /** @class */ (function (_super) {
    tslib_1.__extends(InputPassword, _super);
    function InputPassword(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePasswordToggle = _this.handlePasswordToggle.bind(_this);
        _this.handleBlur = _this.handleBlur.bind(_this);
        _this.state = {
            type: "password"
        };
        return _this;
    }
    InputPassword.prototype.componentWillUnmount = function () {
        window.clearTimeout(this.resetStateAfterBlur);
    };
    InputPassword.prototype.handlePasswordToggle = function (e) {
        e.preventDefault();
        window.clearTimeout(this.resetStateAfterBlur);
        this.setState({
            type: this.state.type === "text" ? "password" : "text"
        });
    };
    InputPassword.prototype.handleBlur = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a;
        this.resetStateAfterBlur = window.setTimeout(function () {
            return _this.setState({
                type: "password"
            });
        }, 100);
        if (this.props.onBlur) {
            (_a = this.props).onBlur.apply(_a, args);
        }
    };
    InputPassword.prototype.render = function () {
        var _a = this.props, inputClassName = _a.inputClassName, type = _a.type, props = tslib_1.__rest(_a, ["inputClassName", "type"]); // eslint-disable-line react/prop-types
        return (React.createElement(Input_1.Input, tslib_1.__assign({}, props, { type: this.state.type, inputClassName: classnames(inputClassName), onBlur: this.handleBlur, iconType: this.state.type === "password" ? "show" : "hide", onIconClick: this.handlePasswordToggle })));
    };
    InputPassword.propTypes = Input_1.Input.propTypes;
    InputPassword.defaultProps = tslib_1.__assign({}, Input_1.Input.defaultProps, { type: "password" });
    InputPassword.HIDE_PASSWORD_AFTER_TOUCH = 2000;
    return InputPassword;
}(React.Component));
exports.InputPassword = InputPassword;